export default __webpack_public_path__ + "static/media/logo.a3ac1f7e.svg";